import React from 'react';
import { useNavigate } from 'react-router-dom';
import { history } from '../../App';
import { useSelector } from 'react-redux';
import { Schedule, Settings, Subscription, User, Users, Recital, logo, } from '../../assets/img';

import styles from './index.module.scss';


function Menu({ isOpenMenu, changeIsOpenMenu, navCollapsed, expandNav }) {
    const { isAdmin, subscription, hasRecitalAddon } = useSelector(state => state.personality.user);
    const activeMenu = history.location.pathname.slice(1) || ((isAdmin ? "users" : "schedule"));
    const navigate = useNavigate();

    const onChangeMenuItem = (e) => {
        const newActiveItem = e.target.getAttribute("data-menu");
        if (!newActiveItem) return;
        navigate(`/${newActiveItem}`);
        changeIsOpenMenu(false);
        if (navCollapsed && expandNav) expandNav();
    }

    const getMenuItem = () => {
        let listItemMenu = []
        let dataMenu = isAdmin ? {
            users:
                { title: 'Users', iconReactComponent: Users },
            subscription:
                { title: 'Subscription ', iconReactComponent: Subscription },
            settings:
                { title: 'Settings', iconReactComponent: Settings }
        } : {
            schedule:
                { title: 'My Schedule', iconReactComponent: Schedule },
            profile:
                { title: 'Profile', iconReactComponent: User },
            subscription:
                { title: 'Subscription ', iconReactComponent: Subscription },
            settings:
                { title: 'Settings', iconReactComponent: Settings }
        }

        dataMenu = subscription?.length > 0 || isAdmin ? dataMenu : {
            subscription:
                { title: 'Subscription ', iconReactComponent: Subscription },
            settings:
                { title: 'Settings', iconReactComponent: Settings }
        };

        // Inject Recitals nav item for studios with the add-on (between Profile and Subscription)
        if (!isAdmin && subscription?.length > 0 && hasRecitalAddon) {
            const entries = Object.entries(dataMenu);
            const subscriptionIndex = entries.findIndex(([key]) => key === 'subscription');
            entries.splice(subscriptionIndex, 0, [
                'recitals',
                { title: 'Recitals', iconReactComponent: Recital, badge: 'PRO' },
            ]);
            dataMenu = Object.fromEntries(entries);
        }

        for (let key in dataMenu) {
            const isActive = key === activeMenu;
            const classNameText = isActive
                ? [styles.menuItem, styles.activeMenuItem].join(' ')
                : styles.menuItem;
            const classNameIcon = isActive
                ? [styles.icon, styles.activeIcon].join(' ')
                : styles.icon;
            const IconComponent = dataMenu[key]['iconReactComponent'];
            const badge = dataMenu[key]['badge'];

            listItemMenu.push(
                <li
                    className={classNameText}
                    data-menu={key}
                    key={key}
                    title={navCollapsed ? dataMenu[key].title : undefined}
                >
                    <div data-menu={key} className={navCollapsed ? styles.itemInnerCollapsed : styles.itemInner}>
                        <IconComponent className={classNameIcon} data-menu={key} />
                        {!navCollapsed && (
                            <span className={styles.navLabel} data-menu={key}>
                                {dataMenu[key].title}
                            </span>
                        )}
                        {!navCollapsed && badge && (
                            <span className={styles.proBadge} data-menu={key}>{badge}</span>
                        )}
                    </div>
                    {!navCollapsed && isActive && <div className={styles.point} />}
                </li>
            )
        }

        return listItemMenu;
    }

    const classNameMenu = isOpenMenu
        ? [styles.menu, styles.activeMenu].join(' ')
        : styles.menu;

    return (
        <div className={classNameMenu}>
            <img
                className={navCollapsed ? styles.logoCollapsed : styles.logo}
                alt='logo'
                src={logo}
            />
            <ul onClick={onChangeMenuItem}>
                {getMenuItem()}
            </ul>
        </div>
    );
}

export default Menu;
